import { Chip, Stack, Typography } from '@mui/material';

import type { EPPriorityUserChipsProps } from './EscalationProfile.types';

const EPPriorityUserChips = ({ users, priority }: EPPriorityUserChipsProps) => {
  if (users.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No users configured for P{priority} notifications
      </Typography>
    );
  }
  return (
    <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1 }}>
      {users.map((u) => (
        <Chip key={u.id} label={u.name} size="small" />
      ))}
    </Stack>
  );
};

export default EPPriorityUserChips;
